import { strEnum } from "../common/types";

export const PollMessageTypeEnum = strEnum(["commentAdd", "pollAdd", "pollUpdate"]);
export const PollTypeEnum = [
    "All",
    "text",
    "image",
    "video",
    "videoPlaySameTime",
    "videoPlayOneByOne",
    "follow",
];
export const PollTypeEnumString = strEnum(PollTypeEnum);

export type PollType = keyof typeof PollTypeEnumString;
export const VideoPlayOptionEnum = strEnum(["OneByOne", "SameTime"]);
export type VideoPlayOptionType = keyof typeof VideoPlayOptionEnum;

export const FileTypeEnum = strEnum(["Image", "Video", "Audio"]);
export type FileType = keyof typeof FileTypeEnum;

export interface PollComment {
    userId: string;
    message: string;
    pollId: string;
    reporters?: Array<Report>;
    id?: string;
    name?: string;
    image?: string;
}
export interface UserPollLink {
    userId: string;
    pollId: string;
    optionId?: string | null; // if it's null then use has not voted within in durationToInteract time.
    pollSeenTime?: Date;
    track?: boolean;
    report?: Pick<Report, "reasonId" | "reasonMessage">;
}
export interface UserUpdate {
    email?: string;
    phoneNumber?: string;
    categoryIds?: Array<string>;
}
export interface Report {
    userId: string;
    reasonId: string;
    reasonMessage?: string;
}
export interface PollOption {
    id: string;
    text?: Array<string>;
    image?: Array<string>;
    video?: Array<string>;
    videoThumb?: Array<string>;
    totalVote?: number;
    systemVoteCount?: number;
}

export interface Poll {
    creatorId: string;
    startDate: Date;
    isPrivate?: boolean;
    anonymouslyCreated?: boolean;
    endDate: Date;
    durationToInteract: number; // number in sec
    questionText: Array<string>;
    video?: string;
    thumbnail?: string;
    options: Array<PollOption>;
    bootExpected?: number;
    categoryIds?: Array<string>;
    videoPlayOption?: VideoPlayOptionType;
    isDelete?: boolean;
    pollType?: PollType;
}

export interface PollRes extends Poll {
    _id: string;
}
export type Mode = "YOURPOLL";
